import { atom } from "jotai"

export const treeAtom = atom([])